import URL from '../helpers/URL';
import Cookie from '../helpers/Cookie';

;$(function() {
	var app 	= {};
	app.button 	= $('.city-switcher');
	app.list 	= $('.city-select');

	var action 		= {};
	action.list 	= {};
	action.button 	= {};
	action.cookie 	= {};

	action.list.isShown = false;
	action.button.active = undefined;
	action.list.show = obj => {
		obj.next().slideDown();
		action.list.isShown = true;
		action.button.active = obj;
	}
	action.list.hide = obj => {
		obj.next().slideUp();
		action.list.isShown = false;
		action.button.active = undefined;
	}
	action.button.click = function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		if (action.list.isShown)
			action.list.hide($(this));
		else
			action.list.show($(this));
	}
	action.list.click = function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		let _ = $(this);

		if (_.hasClass('city-select__item_active')) return app.button.trigger('click');

		action.cookie.write();
		action.send(_.data('city'));
	}
	action.cookie.write = () => Cookie.set('city_ask', '1', {expires: 7*24*60*60});
	action.send = city => {
		$.ajax({
			type: 'POST',
			url: '/api/city/',
			dataType: 'json',
			data: {
				url: URL.full,
				city: city
			},
			success: function(d) {
				if (window.location.href != d.url)
					window.location.href = d.url.split('#')[0];
			}
		});
	}

	app.button.click( action.button.click );
	app.list.children().click( action.list.click );

	$(document).click(e => {
		if (!action.button.active || $(e.target).parents('.city-switcher').length || $(e.target).parents('.city-select').length) return;

		action.button.active.trigger('click');
	});
});